// extracted by mini-css-extract-plugin
module.exports = {"sectionElement":"Section_sectionElement__3knBJ","isDashed":"Section_isDashed__1ODy6","sectionHeading":"Section_sectionHeading__3OFYk"};